import { 
    SOCKS,
    TURTLE_CROSSING_PIN,
    Product
} from '../products';

const classicAdultRecos: Product[] = [
    SOCKS,
    TURTLE_CROSSING_PIN,
];

export default classicAdultRecos;
 